import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["part"]
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "container-fluid" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "container-fluid" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "d-sm-none" }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "container-fluid" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "d-sm-none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InjectStyles = _resolveComponent("InjectStyles")!
  const _component_CatalogsNotifications = _resolveComponent("CatalogsNotifications")!
  const _component_CatalogProductSwitch = _resolveComponent("CatalogProductSwitch")!
  const _component_CatalogsSearchForm = _resolveComponent("CatalogsSearchForm")!
  const _component_CatalogsSearchToolbar = _resolveComponent("CatalogsSearchToolbar")!
  const _component_CatalogsSearchTable = _resolveComponent("CatalogsSearchTable")!
  const _component_CatalogsSearchPagination = _resolveComponent("CatalogsSearchPagination")!
  const _component_ProductsBreadcrumbs = _resolveComponent("ProductsBreadcrumbs")!
  const _component_CatalogProductsMobileNav = _resolveComponent("CatalogProductsMobileNav")!
  const _component_ProductsSearchProductCategories = _resolveComponent("ProductsSearchProductCategories")!
  const _component_ProductsSearchPartCategories = _resolveComponent("ProductsSearchPartCategories")!
  const _component_ProductsSearchFilters = _resolveComponent("ProductsSearchFilters")!
  const _component_ProductsSearchForm = _resolveComponent("ProductsSearchForm")!
  const _component_ProductsSearchFiltersStatus = _resolveComponent("ProductsSearchFiltersStatus")!
  const _component_ProductsSearchToolbar = _resolveComponent("ProductsSearchToolbar")!
  const _component_ProductsSearchSelection = _resolveComponent("ProductsSearchSelection")!
  const _component_ProductsSearchTable = _resolveComponent("ProductsSearchTable")!
  const _component_ProductsTableView = _resolveComponent("ProductsTableView")!
  const _component_ProductsSearchList = _resolveComponent("ProductsSearchList")!
  const _component_ProductsListView = _resolveComponent("ProductsListView")!
  const _component_ProductsSearchGrid = _resolveComponent("ProductsSearchGrid")!
  const _component_ProductsGridView = _resolveComponent("ProductsGridView")!
  const _component_ProductsSearchNoResults = _resolveComponent("ProductsSearchNoResults")!
  const _component_ProductsSearchPagination = _resolveComponent("ProductsSearchPagination")!
  const _component_ProductsPreviewView = _resolveComponent("ProductsPreviewView")!
  const _component_AliasesMobileNav = _resolveComponent("AliasesMobileNav")!
  const _component_ProductsSearchAliasFilters = _resolveComponent("ProductsSearchAliasFilters")!
  const _component_AliasesSearchToolbar = _resolveComponent("AliasesSearchToolbar")!
  const _component_AliasesSearchTable = _resolveComponent("AliasesSearchTable")!
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")!
  const _component_CatalogActionModals = _resolveComponent("CatalogActionModals")!
  const _component_CatalogProductActionModals = _resolveComponent("CatalogProductActionModals")!
  const _component_AliasActionModals = _resolveComponent("AliasActionModals")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "root",
    class: _normalizeClass(["pis-component position-relative", _ctx.componentName]),
    part: _ctx.componentName
  }, [
    _withDirectives(_createElementVNode("div", null, [
      (_ctx.isWebComponent)
        ? (_openBlock(), _createBlock(_component_InjectStyles, {
            key: 0,
            items: _ctx.store?.options.styles
          }, null, 8, ["items"]))
        : _createCommentVNode("", true),
      _createVNode(_component_CatalogsNotifications),
      _createVNode(_component_LoadingIndicator, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_CatalogProductSwitch)
          ]),
          (_ctx.routeData?.view === 'catalogs')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_CatalogsSearchForm),
                  _createVNode(_component_CatalogsSearchToolbar),
                  _hoisted_5,
                  _createVNode(_component_CatalogsSearchTable),
                  _createVNode(_component_CatalogsSearchPagination)
                ])
              ]))
            : (_ctx.routeData?.view === 'products')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_ProductsBreadcrumbs),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", {
                        class: _normalizeClass([_ctx.widerThan('xl') ? 'col-3' : _ctx.widerThan('md') ? 'col-4' : 'col-12'])
                      }, [
                        _withDirectives(_createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_CatalogProductsMobileNav)
                        ], 512), [
                          [_vShow, _ctx.allowMobileView]
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass([_ctx.allowMobileView && 'd-none d-sm-block'])
                        }, [
                          _createVNode(_component_ProductsSearchProductCategories),
                          _createVNode(_component_ProductsSearchPartCategories),
                          _createVNode(_component_ProductsSearchFilters)
                        ], 2)
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass([_ctx.widerThan('xl') ? 'col-9' : _ctx.widerThan('md') ? 'col-8' : 'col-12'])
                      }, [
                        _createVNode(_component_ProductsSearchForm),
                        _createVNode(_component_ProductsSearchFiltersStatus),
                        _createVNode(_component_ProductsSearchToolbar),
                        _createVNode(_component_ProductsSearchSelection, { class: "mb-2" }),
                        _createVNode(_component_ProductsTableView, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ProductsSearchTable)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ProductsListView, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ProductsSearchList)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ProductsGridView, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ProductsSearchGrid)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ProductsSearchNoResults),
                        _createVNode(_component_ProductsSearchPagination),
                        _createVNode(_component_ProductsPreviewView)
                      ], 2)
                    ])
                  ])
                ]))
              : (_ctx.routeData?.view === 'aliases')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_ProductsBreadcrumbs),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", {
                          class: _normalizeClass([_ctx.widerThan('xl') ? 'col-3' : _ctx.widerThan('md') ? 'col-4' : 'col-12'])
                        }, [
                          _withDirectives(_createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_AliasesMobileNav)
                          ], 512), [
                            [_vShow, _ctx.allowMobileView]
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass([_ctx.allowMobileView && 'd-none d-sm-block'])
                          }, [
                            _createVNode(_component_ProductsSearchAliasFilters),
                            _createVNode(_component_ProductsSearchProductCategories),
                            _createVNode(_component_ProductsSearchPartCategories)
                          ], 2)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass([_ctx.widerThan('xl') ? 'col-9' : _ctx.widerThan('md') ? 'col-8' : 'col-12'])
                        }, [
                          _createVNode(_component_ProductsSearchForm),
                          _createVNode(_component_AliasesSearchToolbar),
                          _createVNode(_component_AliasesSearchTable),
                          _createVNode(_component_ProductsSearchNoResults),
                          _createVNode(_component_ProductsSearchPagination)
                        ], 2)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, _ctx.isReady]
    ]),
    _createVNode(_component_CatalogActionModals, {
      t: _ctx.t,
      "instance-id": _ctx.instanceId
    }, null, 8, ["t", "instance-id"]),
    _createVNode(_component_CatalogProductActionModals, {
      t: _ctx.t,
      "instance-id": _ctx.instanceId
    }, null, 8, ["t", "instance-id"]),
    _createVNode(_component_AliasActionModals, {
      t: _ctx.t,
      "instance-id": _ctx.instanceId
    }, null, 8, ["t", "instance-id"])
  ], 10, _hoisted_1))
}